var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"loading-indicator-card"},[_c('v-card-text',[_vm._v("\n            "+_vm._s(_vm.loadingText)+"\n            "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }